import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { useTranslation } from '@/hooks/useTranslations';
import { OfferCardFeature } from './OfferCardFeature';
export function OfferCardFeatureList({ featuresTitle, features, }) {
    const { t } = useTranslation();
    return (_jsxs(Box, { testId: "offer-card-features-list-container", display: "flex", flexDirection: "column", gap: "spacing.24", children: [_jsx(Box, { typography: "typography.body.16.bold", children: t(featuresTitle) }), features.map((feature, i) => (
            // eslint-disable-next-line react/no-array-index-key
            _jsx(OfferCardFeature, { feature: feature }, i)))] }));
}
